import 'arrive';
import Swiper from 'swiper/bundle';


function clamp(min, val, max) {
  return Math.min(Math.max(val, min), max);
}
function getSwiperGap() {
  return clamp(20, window.innerWidth * 0.0167, 32); 
}

document.arrive('.block-related-post', { existing: true }, function (el) {
  const container = el.querySelector('.block-related-post__grid.swiper');
  if (!container || container.dataset.swiperInitialized === 'true') return;

  // Mark as initialized to avoid duplicates
  container.dataset.swiperInitialized = 'true';

  // On mobile, turn grid into slider with 1.2 slides per view and no effect
  const swiper = new Swiper(container, {
    slidesPerView: 3,
    spaceBetween: getSwiperGap(),
    loop: false,
    freeMode: true,
    allowTouchMove: true,
    breakpoints: {
        1080: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 2.5,
        },
        500: {
            slidesPerView: 1.8,
        },
    },
  });

  // aggiorna il gap al resize
  window.addEventListener('resize', () => {
    swiper.params.spaceBetween = getSwiperGap();
    swiper.update();
  });
});